import React from "react";
import CloseSvg from '../../svgComponents/CloseSvg';

const CloseModalButton = ({ closeModal }) => {
  return (
    <button
      type="button"
      onClick={closeModal}
      className="w-[30px] h-[30px] md:w-10 md:h-10 rounded-lg flex items-center justify-center bg-white hover:bg-[#f0f4ff] border border-deepBlue shadow-maxButtonShadow dark:bg-transparent dark:hover:!bg-[#36345F]"
    >
      <CloseSvg />
    </button>
  );
};

export default CloseModalButton;
